import Vue from "vue";
import VueRouter from "vue-router";
import { TokenService } from "@/api/storage.js";
import { initialize, initializePersonalData } from "@/api";
import MainStore from "@/store";

Vue.use(VueRouter);

const routes = [];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  // let token = to.params.token;
  // if (token) {
  //   TokenService.saveToken(JSON.stringify(token));
  //   initialize(TokenService.getToken());
  //   initializePersonalData(TokenService.getToken());
  // }
  if (to.matched.length == 0) {
    next("/login");
  } else if (to.meta.requiresAuth) {
    // redirect to login if the user to try acess any other route without login
    if (!TokenService.getToken()) {
      MainStore.dispatch("auth/saveRouteWithoutToken", to);
      next("/login");
    } else {
      initialize(TokenService.getToken());
      initializePersonalData(TokenService.getToken());
      next();
    }
  } else {
    next();
  }
});

export default router;
